import React, { useState } from "react";
import { commonDateFilterKeys } from "../../../utils/wildCardFilterUtils";
import { dateTimeFinder } from "../../../config/utils";
import moment from "moment";

export const CommonDateFilter = ({ filterItem, searchKey, handleDateFilterChanges }) => {
    const [tempDateFilter, setTempDateFilter] = useState(filterItem || {});
    const onDateInputChange = (value, key, subKey) => {
        let currentFilter = tempDateFilter || {};
        const item = currentFilter?.[key] || {};
        if (value) {
            currentFilter = {
                ...currentFilter,
                [key]: {
                    filters: [],
                    key: { ...item.key, [subKey]: value }
                }
            };
        }
        setTempDateFilter(currentFilter);
    };
    const setFilterKeyForDate = (filterKey, searchKey, checked, isClear) => {
        let currentFilter = isClear ? {} : tempDateFilter;
        let item = currentFilter?.[searchKey] || {};
        item = {
            ...item,
            key:
                checked && filterKey !== "in_between"
                    ? dateTimeFinder(filterKey)
                    : item?.key
                    ? {
                          from: moment(item?.key?.from)?.format("YYYY-MM-DD"),
                          to: moment(item?.key?.to)?.format("YYYY-MM-DD")
                      } || item.key
                    : {},
            filters: checked && filterKey === "in_between" ? ["in_between"] : [],
            filterKey: checked ? [filterKey] : []
        };
        currentFilter = { ...currentFilter, [searchKey]: item };
        setTempDateFilter(currentFilter);
        (checked || isClear) && updateWildCardFilter(isClear ? {} : currentFilter);
    };
    const updateWildCardFilter = filter => {
        let updatedFilterData = { ...filter };
        const filteredWildCardData = Object.entries(updatedFilterData || {}).reduce((result, [key, elem]) => {
            if (
                elem?.key?.toString()?.trim().length ||
                elem?.filters?.[0] === "null" ||
                elem?.filters?.[0] === "not_null" ||
                elem?.filters?.[0] === "count_gt_1"
            ) {
                result[key] = elem;
            }
            return result;
        }, {});
        handleDateFilterChanges(filteredWildCardData);
    };
    return (
        <div className="dropdown-menu drop-filtr sub-drop">
            <div className="slct-date-otr">
                <div className="place-holder">
                    <div className="col-md-2 p-0 labl-txt">From</div>
                    <div className="col-md-10 pr-0">
                        <input
                            value={
                                tempDateFilter?.[searchKey]?.key?.from
                                    ? moment(tempDateFilter?.[searchKey]?.key?.from).format("yyyy-MM-DD")
                                    : moment().format("DD-MM-YY")
                            }
                            type="date"
                            onChange={e => onDateInputChange(e.target.value, searchKey, "from")}
                        />
                    </div>
                </div>
                <div className="place-holder">
                    <div className="col-md-2 p-0 labl-txt">To</div>
                    <div className="col-md-10 pr-0">
                        <input
                            value={
                                tempDateFilter?.[searchKey]?.key?.to
                                    ? moment(tempDateFilter?.[searchKey]?.key?.to).format("yyyy-MM-DD")
                                    : moment().format("DD-MM-YY")
                            }
                            type="date"
                            onChange={e => onDateInputChange(e.target.value, searchKey, "to")}
                        />
                    </div>
                </div>
            </div>
            <div className="check-box-otr-dte d-flex col-md-12">
                {commonDateFilterKeys.map((item, i) => (
                    <>
                        <div key={i} className="col-md-6 p-0">
                            <span className="dropdown-item">
                                <label className="container-check">
                                    {item.label}
                                    {item.value ? (
                                        <>
                                            <input
                                                type="checkbox"
                                                checked={tempDateFilter?.[searchKey]?.filterKey?.includes(item.value) || false}
                                                onClick={e => setFilterKeyForDate(item.value, searchKey, e.target.checked)}
                                            />
                                            <span className="checkmark"></span>
                                        </>
                                    ) : null}
                                </label>
                            </span>
                        </div>
                        {i % 6 === 1 ? <div className="col-md-12 dropdown-line"></div> : null}
                    </>
                ))}
            </div>
            <div className="clear-btn">
                <button
                    className={`clear-btn-selection `}
                    onClick={() => {
                        setTempDateFilter({});
                        setFilterKeyForDate(null, searchKey, null, true);
                    }}
                >
                    Clear
                </button>
            </div>
        </div>
    );
};
